@if (cartPreviewItem) {
  <div class="cart-preview-item d-flex mx-2 my-1">
    <a class="thumbnail-container" [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber }">
      <img class="w-64px h-max-64px obj-fit-contain obj-position-bottom" [src]="cartPreviewItem.thumbnail" alt="cartPreviewItem thumbnail" />
    </a>
    <span class="mx-2 w-100">
      <a [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber }">
        {{ cartPreviewItem.description }}
      </a>
      <div class="d-flex">
        <span i18n="@@CartPreviewItemProductNumber" class="me-auto">Item #</span>
        <a [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber }">
          {{ cartPreviewItem.productIdentifier!.productNumber }}
        </a>
      </div>
      <div class="d-flex align-items-center">
        @if (cartPreviewItemDisplayAvailabilityIcon) {
          <app-product-availability-icon [productAvailabilityState]="cartPreviewItem.availability?.productAvailabilityState"> </app-product-availability-icon>
        }
        <span class="ms-auto"></span>
        <div class="d-flex justify-content-end">
          <app-quantity-input-bare
            [quantity]="cartPreviewItem.shoppingCartItem!.quantity"
            [min]="cartPreviewItem.minimumOrderAmount"
            [max]="cartPreviewItem.maximumOrderAmount"
            (onQuantityChanged)="quantityChanged($event)"
            (onProductRemoveFromCart)="deleteItem()"
          >
          </app-quantity-input-bare>
          <span class="input-group-text p-1">{{ cartPreviewItem.orderUnit?.quantityUnitCaption }}</span>
        </div>
      </div>
      <div class="d-flex align-items-end">
        <app-product-delete-icon [toolTipHtmlContent]="deleteIconTooltipHtmlContent" (deleteSubmit)="deleteItem()"> </app-product-delete-icon>
        <span class="ms-auto"></span>
        @if (cartPreviewItemDisplayPrice) {
          <app-price-format [priceFormat]="cartPreviewItem.priceFormat" [displayDiscounts]="cartPreviewItemDisplayDiscounts"> </app-price-format>
        }
      </div>
    </span>
  </div>
}
